export default __webpack_public_path__ + "static/media/emotion-l.883f6494.png";